import { combineReducers, createStore } from 'redux'
import homeReducer, { Store as HomeStore } from './home/reducer'
import errorReducer, { Store as ErrorStore } from './error/reducer'

export type Store = {
  home: HomeStore
  error: ErrorStore
}
export const mainReducer = combineReducers({
  home: homeReducer,
  error: errorReducer
})
export default createStore(mainReducer)
